import { render, staticRenderFns } from "./PDPDealStory.vue?vue&type=template&id=b9f469c2&scoped=true&"
import script from "./PDPDealStory.vue?vue&type=script&lang=js&"
export * from "./PDPDealStory.vue?vue&type=script&lang=js&"
import style0 from "./PDPDealStory.vue?vue&type=style&index=0&id=b9f469c2&prod&lang=css&"
import style1 from "./PDPDealStory.vue?vue&type=style&index=1&id=b9f469c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f469c2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListingTypeLogo: require('/app/appsumo/nuxt/components/pdp/ListingTypeLogo.vue').default,ShareModal: require('/app/appsumo/nuxt/components/common/ShareModal.vue').default,TacoRating: require('/app/appsumo/nuxt/components/TacoRating.vue').default,ProductsMainImage: require('/app/appsumo/nuxt/components/pdp/carousel/ProductsMainImage.vue').default,PDPPricingCard: require('/app/appsumo/nuxt/components/pdp/PDPPricingCard.vue').default,PDPTldr: require('/app/appsumo/nuxt/components/pdp/PDPTldr.vue').default,ProductsAtGlance: require('/app/appsumo/nuxt/components/products/at-a-glance/ProductsAtGlance.vue').default,ProductsOverview: require('/app/appsumo/nuxt/components/products/overview/ProductsOverview.vue').default,DealTermsAndFeatures: require('/app/appsumo/nuxt/components/products/terms-and-features/DealTermsAndFeatures.vue').default,PricingTable: require('/app/appsumo/nuxt/components/products/pricing-table/PricingTable.vue').default})
